import { GetterTree } from 'vuex'

import { RootState, BrandSkuState } from '@/types/store'

export interface BrandSkuGetters extends GetterTree<BrandSkuState, RootState> {
  brandSkus: (state: BrandSkuState) => BrandSkuState['brandSkus']
}

export const getters: GetterTree<BrandSkuState, RootState> = {
  brandSkus(state): BrandSkuState['brandSkus'] {
    return state.brandSkus
  },
  isBrandSkusLoading(state): BrandSkuState['isBrandSkusLoading'] {
    return state.isBrandSkusLoading
  },
}
